import { Route, Routes } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import LoggeIn from "./components/LoggeIn";
import jwt_decode from "jwt-decode";
import Page404 from "./pages/Page404";
import Login from "./components/adminLogin/Login";
import Schools from "./pages/data/Schools";
import Students from "./pages/data/student/Students";
import Videos from "./pages/basicContent/Videos";
import Questions from "./pages/basicContent/questions/Questions";
import WorksheetPage from "./pages/basicContent/WorksheetPage";
import Modules from "./pages/data/Modules";
import LevelPage from "./pages/data/Level";
import ReadingMaterials from "./pages/basicContent/ReadingMaterials";
import ViewAllStudentBySchool from "./pages/data/ViewAllStudentBySchool";
import AddUsers from "./pages/users/AddUsers";
import QrDataPage from "./pages/basicContent/QrData";
import QrDataView from "./pages/basicContent/qrdataview/qrdataview";
import Banner from "./pages/basicContent/banner/Banner";
import StudentAnalytics from "./pages/data/analytics/student_analytics";
import SchoolAnalytics from "./pages/data/analytics/school_analytics";
import RoadSafetyClub from "./pages/basicContent/RoadSafetyClub";
import AddAminModuleLevelPermission from "./pages/users/AddAminModuleLevelPermission";
import Notification from "./pages/basicContent/Notification/Notification";
import SupportTicket from "./pages/basicContent/SupportTicket";
import StudentTab from "./pages/data/StudentTab";

function App() {
  const logCheck = localStorage.getItem("data");
  let decoded_data = "";
  if (logCheck != null) {
    decoded_data = jwt_decode(logCheck);
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        {/* <Route path='/support' element={<SupportPage />} />
        <Route path='/delete_account' element={<DeleteAccount />} />
        <Route path='/privacy' element={<Privacy />} />
        <Route path='/terms_and_condition' element={<TermsAndConditon />} />
        <Route path='/no_refund_policy' element={<NoPolicyRefund />} />
        <Route path="qr_scan" element={<QrScan />} /> */}
        {logCheck !== null ? (
          <>
            <Route path="/*" element={<LoggeIn />}>
              {/* Add your nested routes inside the LoggeIn component here */}
              <Route index element={<Dashboard />} />
              <Route path="add-users" element={<AddUsers />} />
              <Route path="add-admin" element={<AddAminModuleLevelPermission />} />
              <Route path="banners" element={<Banner />} />
              <Route path="notifications" element={<Notification />} />
              <Route path="students" element={<StudentTab />} />
              <Route path="schools" element={<Schools />} />
              <Route path="modules" element={<Modules />} />
              <Route path="levels" element={<LevelPage />} />
              <Route path="videos" element={<Videos />} />
              <Route path="readingmaterials" element={<ReadingMaterials />} />
              <Route path="worksheets" element={<WorksheetPage />} />
              <Route path="questions" element={<Questions />} />
              <Route
                path="view-all-students-by-school"
                element={<ViewAllStudentBySchool />}
              />
              <Route path="qr-data" element={<QrDataPage />} />
              <Route
                path="studentanalytics"
                element={<StudentAnalytics />}
              />
              <Route path="schoolanalytics" element={<SchoolAnalytics />} />
              <Route path="road-safety-club" element={<RoadSafetyClub />} />
              <Route path="support-ticket" element={<SupportTicket />} />

              {/* <Route path="qr-data-view" element={<QrDataView />} /> */}
            </Route>
          </>
        ) : (
          <Route path="/" element={<Login />} />
        )}

        <Route path="*" element={<Page404 />} />
      </Routes>
    </>
  );
}

export default App;
